
export default function logger(store: any) {
    return (dispatch: any) => (action: any): any => {
        const result = dispatch(action);
        return result;
    }
}